const features = [
  {
    icon: 'ri-book-open-line',
    title: '全章节免费阅读',
    desc: '无需注册登录，所有韩漫全章节免费开放。从第一话到最新话，完整阅读不受限制，真正实现韩漫全集免费看。',
  },
  {
    icon: 'ri-hd-line',
    title: '高清原画质呈现',
    desc: '采用韩漫原画级分辨率展示，每一笔线条、每一处分镜都清晰锐利。支持自适应屏幕缩放，手机与桌面端均享最佳画质。',
  },
  {
    icon: 'ri-scroll-to-bottom-line',
    title: '下拉式流畅阅读',
    desc: '专为韩漫竖屏阅读优化，原生下拉式滚动体验，完美适配韩漫纵向分镜叙事风格，让阅读如同翻阅纸质漫画般自然。',
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
            平台优势
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            为什么超过百万读者选择韩漫屋？三大核心优势，重新定义韩漫阅读体验
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
          {features.map((feature) => (
            <div
              key={feature.title}
              className="group p-6 md:p-8 rounded-2xl bg-background-50 border border-background-200/70 hover:border-primary-200 transition-all duration-200"
            >
              <span className="w-14 h-14 rounded-2xl bg-primary-100 text-primary-600 flex items-center justify-center mb-5">
                <i className={`${feature.icon} text-2xl`}></i>
              </span>
              <h3 className="font-heading text-lg font-semibold text-foreground-900 mb-3">
                {feature.title}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed">
                {feature.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}